import HeaderSubSection from "../../components/HeaderSubSection/index.vue";
import aboutSection from "../../components/aboutSection/index.vue";

export default {
  name: "homePage",
  components: {
    HeaderSubSection,
    aboutSection,
  },
};
